export interface InitialTransferPaintInput {
  sessionReady: boolean;
  /** Pinned amount is known, including a claim that has no amount. */
  amountResolved: boolean;
  /** There is an amount that still needs a price. */
  needsPrice: boolean;
  pricingLoading: boolean;
  pricingSettled: boolean;
  methodsLoading: boolean;
}

/**
 * First Transfer paint. Later amount or method edits must not call this again:
 * the page latches the first `true` and keeps the in-place quote loading.
 */
export function isInitialTransferPaintReady(
  input: InitialTransferPaintInput,
): boolean {
  if (!input.sessionReady || input.methodsLoading || !input.amountResolved) {
    return false;
  }
  if (!input.needsPrice) return true;
  if (input.pricingLoading) return false;
  return input.pricingSettled;
}
